import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes, Router } from "@angular/router";
import { LandingComponent } from "./pages/landing/landing.component";
import { HotelComponent } from "./pages/hotel/hotel.component";
import { PrivacyComponent } from "./pages/privacy/privacy.component";
import { NotfoundComponent } from "./components/notfound/notfound.component";
import { TravelOptionsComponent } from "./components/traveloptions/traveloptions.component";

const routes: Routes = [
  {
    path: "notfound",
    component: NotfoundComponent,
  },
  {
    path: "traveloptions",
    component: TravelOptionsComponent,
  },
  {
    path: ":promotionAlias",
    component: LandingComponent,
    pathMatch: "full",
  },
  {
    path: ":promotionAlias/privacy",
    component: PrivacyComponent,
  },
  {
    path: ":promotionAlias/vehicles",
    loadChildren: "app/vehicles/vehicles.module#VehiclesModule",
  },
  {
    path: ":promotionAlias/Vehicles",
    loadChildren: "app/vehicles/vehicles.module#VehiclesModule",
  },
  {
    path: "hotel/:promotionAlias",
    component: HotelComponent,
    pathMatch: "full"
  },
  {
    path: "hotel/:promotionAlias/privacy",
    component: PrivacyComponent,
    data : { isHotelPromotion : true }
  },
  {
    path: "**",
    component: NotfoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
